import { useEffect, useState } from 'react';

interface StorageEstimate {
  quota?: number;
  usage?: number;
}

const useStorageSpace = (): StorageEstimate | null => {
  const [storageEstimate, setStorageEstimate] = useState<StorageEstimate | null>(null);

  useEffect(() => {
    const getStorageSpace = async (): Promise<void> => {
      if ('storage' in navigator && 'estimate' in navigator.storage) {
        try {
          const estimate = await navigator.storage.estimate();
          setStorageEstimate({
            quota: estimate.quota,
            usage: estimate.usage,
          });
        } catch (error) {
          console.error('Error estimating storage:', error);
        }
      } else {
        console.warn('StorageManager API not supported in this browser.');
      }
    };

    getStorageSpace();
  }, []);

  return storageEstimate;
};

export default useStorageSpace;
